module.exports = __webpack_public_path__ + "img/destination-loreto.bbf32f65.jpg";